import { HeaderLink, headerLinks } from "./assets/headerLinks";

export default function HeaderLinks(): JSX.Element {
  const renderHeaderLinks = () => {
    return headerLinks.map((link: HeaderLink) => (
      <li className="header-link">
        <a href={link.href}>{link.title}</a>
      </li>
    ));
  };
  return <ul className="header-links">{renderHeaderLinks()}</ul>;
}
